export default __webpack_public_path__ + "static/media/innovid.3a276fab.svg";